export class InvalidInspectionTemplateParamsError extends Error {
  constructor(message = 'Template id and channel id are required') {
    super(message);
    this.name = 'InvalidInspectionTemplateParamsError';
  }
}
